import script from "./MarketPlaceSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPlaceSelector.vue?vue&type=script&setup=true&lang=js"

import "./MarketPlaceSelector.vue?vue&type=style&index=0&id=2145ccde&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2145ccde"]])

export default __exports__